import React, { Component, PropTypes } from 'react';
import { connectReduxForm } from 'redux-form';
import { Link } from 'react-router';
import { validateLogin } from 'utils/validateNormalize';
import Spinner from 'react-spinner';
import 'react-spinner/react-spinner.css';
import './spinnerButton.scss';

@connectReduxForm({
  form: 'login',
  fields: ['email', 'password', 'alert'],
  validate: validateLogin
})
export default class SigninForm extends Component {
  static propTypes = {
    fields: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submitting: PropTypes.bool.isRequired
  }

  render () {
    const { fields: {
              alert,
              email,
              password},
            handleSubmit,
            submitting } = this.props;

    return (
      <form onSubmit={handleSubmit}
            className="form-horizontal">
        <h2>Sign in</h2>
        {alert.error &&
        <div className="form-group">
          <div className="alert alert-danger" dangerouslySetInnerHTML={{__html: alert.error}}>
          </div>
        </div>
        }
        <div className="row">
          <div className="col-sm-8 col-md-8">

            <div className={'form-group ' +
                            (email.error && email.touched && 'has-error')}>
              <label htmlFor="txtEmail"
                     className="col-sm-2 control-label">
                Email
              </label>
              <div className="col-sm-9">
                <input id="txtEmail"
                       type="email"
                       className="form-control"
                       placeholder="jane@example.com"
                       spellCheck="false"
                       {...email} />
                {email.error && email.touched &&
                 <div className="text-danger" dangerouslySetInnerHTML={{__html: email.error}}></div>
                }
              </div>
            </div>
            <div className={'form-group ' +
                            (password.error && password.touched ? 'has-error' : '')}>
              <label htmlFor="txtPassword"
                     className="col-sm-2 control-label">
                Password
              </label>
              <div className="col-sm-9">
                <input id="txtPass"
                       type="password"
                       className="form-control"
                       placeholder="thoo!mu3Da"
                       {...password} />
                {password.error && password.touched &&
                  <div className="text-danger" dangerouslySetInnerHTML={{__html: password.error}}></div>
                }
              </div>
            </div>
            <div className="form-group">
              <div className="col-sm-offset-2 col-sm-9">
                <button type="submit"
                        className={'btn btn-lg btn-primary spinnerButton ' +
                                   (submitting ? 'disabled' : '')}>
                  <div className="buttonContent">
                    <div className="buttonText">
                      {submitting ?
                        'Signing in' :
                        'Sign in'
                      }
                    </div>
                    {submitting &&
                    <div className="spinnerWrapper">
                      <Spinner />
                    </div>
                    }
                  </div>
                </button>
                <span style={{marginLeft: '1em'}}>
                  <Link to="/forgotPassword">Forgot password?</Link>
                </span>
              </div>
            </div>
          </div>
        </div>
      </form>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/auth/signinForm.jsx